const coopTermsList = ["Winter 2022", "Spring 2022", "Fall 2022", "Full-time"];

export const coopTerms = coopTermsList.map((v) => ({
  label: v,
  value: v,
}));
export default coopTerms;
